module.exports = __webpack_public_path__ + "static/Apartmani-Mima-Sokobanja-11-ebd6d6c1dc161447ad7ef2d3cbccfca1.jpg";